import getPriceShow from './getPriceShow';

export default function init() {
    const priceShow = getPriceShow();
    if (priceShow.shouldShowBvPv) {
        document.getElementsByTagName('body')[0].classList.add('showBvPv');
    }
}
